import React from "react";
import {Route, Switch, Redirect} from "react-router-dom";
import AddEventSubCategory from "./add";
import ListEventSubCategory from "./list";
import CustomBreadCrumb from 'components/Widgets/CustomBreadCrumb';

const Main = ({match}) => (
  <div>
    <CustomBreadCrumb />
  <Switch>
    <Route path={`${match.url}/add`} component={AddEventSubCategory}/>
    <Route path={`${match.url}/edit/:id`} component={AddEventSubCategory}/>
    <Route path={`${match.url}/list`} component={ListEventSubCategory}/>
    <Route exact path={`${match.url}/`}>
      <Redirect to={`${match.url}/list`} />
    </Route>
  </Switch>
  </div>
);

export default Main;
